var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{'btn--loading': _vm.loading},attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.loading)?_c('div',{staticClass:"btn__loader"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }